import { render, staticRenderFns } from "../../../../components/shared/physicianSearch/BaseSearchBoxV2.html?vue&type=template&id=610872c1&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "../../../../components/shared/physicianSearch/BaseSearchBoxV2.css?vue&type=style&index=0&id=610872c1&scoped=true&lang=css&"
import style1 from "./SearchBox.vue?vue&type=style&index=1&id=610872c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610872c1",
  null
  
)

component.options.__file = "SearchBox.vue"
export default component.exports